import { YEAR_CONTENT_SLIDER_PROPS, TIMELINE_SLIDER_PROPS } from "./slickProps";

const Timeline = () => {
  const block = $(".block-timeline");
  if (block.length) {
    const yearsContent = window.blockTimeline;
    const contentPerYearSlider = block.find(".content-per-year-slider");
    const squareBulletsPag = block.find(".square-bullets-pagination");

    contentPerYearSlider.slick(YEAR_CONTENT_SLIDER_PROPS);

    contentPerYearSlider.on("afterChange", (e, slick, currSlide) => {
      squareBulletsPag.children().removeClass("active");
      squareBulletsPag.children().eq(currSlide).addClass("active");
    });

    const changeYearContent = (yearIndex) => {
      let sliderContent = [];
      const events = yearsContent[yearIndex].events;
      squareBulletsPag.empty();
      events.forEach((event) => {
        sliderContent.push(
          `
          <div class="slider-per-year-item">
            <div class="row g-0">
                <div class="col-md-7 bg-white">
                <div class="pt-50">
                  <p>${event.date}</p>
                  <div>
                    ${event.content}
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="bg-white shadow-md">
                  <div class="ratio ratio-189x125">
                    <div class="d-flex bg-cover bg-no-repeat bg-center"
                    style="background-image: url(${event.image});"
                    >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          `
        );
        squareBulletsPag.append("<span></span>");
      });
      squareBulletsPag.children().first().addClass("active");
      contentPerYearSlider.slick("unslick");
      contentPerYearSlider.empty().append(sliderContent.join(""));
      contentPerYearSlider.slick(YEAR_CONTENT_SLIDER_PROPS);
    };

    const slider = $(".timeline-slider").slick(TIMELINE_SLIDER_PROPS);

    block.on(
      "click tap touchstart",
      ".square-bullets-pagination > span",
      (e) => {
        const self = $(e.currentTarget);
        self.siblings().removeClass("active");
        self.addClass("active");
        contentPerYearSlider.slick("slickGoTo", self.index());
      }
    );

    $(".block-timeline .timeline-slider-buttons > span").on(
      "click tap touchstart",
      function () {
        const dir = $(this).data("direction");
        slider.slick(dir);
      }
    );
    $(".timeline-slider .slick-slide").on("click tap touchstart", (e) => {
      const slideClicked = $(e.currentTarget).attr("data-slick-index");
      slider.slick("slickGoTo", parseInt(slideClicked));
    });

    slider.on("afterChange", (e, slick, currSlide) => {
      changeYearContent(currSlide);
    });
  }
};

export default Timeline;
